/**
 * Power of Attorney (Go-live 1 November checklist): who empowers whom, for
 * which roles, for which period. Superuser-only endpoints in
 * backend/employees/power_of_attorney_views.py. Never shortened to "POA"
 * (that is the Proof of Address document code).
 *
 * Errors are re-thrown untouched; screens show `response.data.error`.
 */
import axiosInstance from '../utils/axiosConfig';

const LIST = '/api/admin/hms/power-of-attorney/';
const ROLES = '/api/admin/hms/system-data/power-of-attorney-roles/';

const powerOfAttorneyService = {
  /** Every power of attorney; `employee` (given or held) and `status` narrow it. */
  list: async ({ employee, status } = {}) => {
    const params = {};
    if (employee) params.employee = employee;
    if (status) params.status = status;
    return (await axiosInstance.get(LIST, { params })).data.powers_of_attorney || [];
  },
  create: async (payload) => (await axiosInstance.post(LIST, payload)).data.power_of_attorney,
  update: async (id, payload) => (await axiosInstance.patch(`${LIST}${id}/`, payload)).data.power_of_attorney,
  revoke: async (id) => (await axiosInstance.post(`${LIST}${id}/revoke/`, {})).data.power_of_attorney,

  /** The "Which roles" list, switched-off roles included. */
  listRoles: async () => (await axiosInstance.get(ROLES)).data.roles || [],
  createRole: async (name) => (await axiosInstance.post(ROLES, { name })).data.role,
  updateRole: async (id, patch) => (await axiosInstance.patch(`${ROLES}${id}/`, patch)).data.role,
};

export default powerOfAttorneyService;
